import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';
import ITTrainingHeader from '../../components/ITTrainingHeader';
import ITTrainingFooter from '../../components/ITTrainingFooter';

const categories = ['All', 'Programming', 'Web Design', 'Career Tips', 'Digital Marketing', 'Industry News'];

const posts = [
  {
    id: 1,
    category: 'Programming',
    date: 'April 20, 2026',
    title: 'Why Python Is the #1 Language to Learn in 2026',
    excerpt: 'Python continues to dominate the programming world. Whether you want to build AI models, automate workflows, or launch a data science career — here\'s why Python should be your first language.',
    readTime: '5 min read',
    emoji: '🐍',
  },
  {
    id: 2,
    category: 'Career Tips',
    date: 'April 15, 2026',
    title: '10 Tips to Land Your First IT Job After Training',
    excerpt: 'Getting your first job in IT can feel overwhelming. These 10 proven strategies — from building a GitHub portfolio to acing technical interviews — will help you stand out and get hired faster.',
    readTime: '7 min read',
    emoji: '💼',
  },
  {
    id: 3,
    category: 'Web Design',
    date: 'April 10, 2026',
    title: 'Top 5 Web Design Trends You Need to Know in 2026',
    excerpt: 'From glassmorphism to AI-generated layouts, web design is evolving fast. Stay ahead of the curve with these 5 design trends that top agencies are using right now.',
    readTime: '4 min read',
    emoji: '🎨',
  },
  {
    id: 4,
    category: 'Digital Marketing',
    date: 'April 5, 2026',
    title: 'How to Build a Winning SEO Strategy from Scratch',
    excerpt: 'Search engine optimisation doesn\'t have to be complicated. This step-by-step guide walks you through keyword research, on-page optimisation, and link building — even if you\'re a complete beginner.',
    readTime: '6 min read',
    emoji: '🔍',
  },
  {
    id: 5,
    category: 'Programming',
    date: 'March 28, 2026',
    title: 'Android vs iOS Development: Which Should You Learn First?',
    excerpt: 'Both platforms offer exciting career opportunities, but the right choice depends on your goals, device preferences, and the local job market. We break down the pros and cons of each.',
    readTime: '5 min read',
    emoji: '📱',
  },
  {
    id: 6,
    category: 'Industry News',
    date: 'March 20, 2026',
    title: 'The Rise of IoT: Career Opportunities in 2026 and Beyond',
    excerpt: 'The Internet of Things is transforming industries from healthcare to agriculture. Discover the skills you need, the sectors that are hiring, and how Vedanskrix\'s IoT training can get you started.',
    readTime: '4 min read',
    emoji: '🌐',
  },
  {
    id: 7,
    category: 'Career Tips',
    date: 'March 12, 2026',
    title: 'How to Build a Portfolio That Gets You Hired',
    excerpt: 'A strong portfolio can open doors that a resume alone cannot. Learn how to structure your projects, write compelling case studies, and present your work to impress technical interviewers.',
    readTime: '6 min read',
    emoji: '🗂️',
  },
  {
    id: 8,
    category: 'Web Design',
    date: 'March 5, 2026',
    title: 'Responsive Design Best Practices Every Developer Should Know',
    excerpt: 'With mobile traffic now exceeding desktop, responsive design is no longer optional. Master fluid grids, flexible images, and media queries with these essential best practices.',
    readTime: '5 min read',
    emoji: '📐',
  },
  {
    id: 9,
    category: 'Digital Marketing',
    date: 'February 25, 2026',
    title: 'Google Ads vs Facebook Ads: Which Gives Better ROI?',
    excerpt: 'Two of the most powerful paid advertising platforms — but which one should your business invest in? We compare targeting options, costs, and performance metrics to help you decide.',
    readTime: '5 min read',
    emoji: '📣',
  },
];

function ITBlog() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  const filtered = posts.filter(p => {
    const matchCat = activeCategory === 'All' || p.category === activeCategory;
    const matchSearch = p.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchCat && matchSearch;
  });

  return (
    <div className="itp-shell">
      <Seo
        title="IT Training Blog | Programming Tips, Career Advice, Tech News | Vedanskrix"
        description="Read the latest IT training blog articles from Vedanskrix. Programming tips, career guidance, technology trends, and industry insights."
        keywords={['IT training blog','programming blog','career advice IT','tech news','python tips','job search tips','programming tutorials','technology trends 2026']}
      />
      <ITTrainingHeader />

      {/* Hero */}
      <section className="itpage-hero itpage-hero--blog">
        <div className="itpage-hero__overlay" />
        <div className="itp-container itpage-hero__content">
          <p className="itpage-hero__eyebrow">Vedanskrix IT Training</p>
          <h1 className="itpage-hero__title">IT Training Blog</h1>
          <p className="itpage-hero__sub">Tips, tutorials, career advice, and industry insights from our trainers</p>
          <div className="itpage-hero__crumb">
            <Link to="/it-training">Home</Link>
            <span> › </span>
            <span>Blog</span>
          </div>
        </div>
      </section>

      {/* Blog Content */}
      <section className="itpage-section">
        <div className="itp-container">

          {/* Search + Filter */}
          <div className="itblog-controls">
            <input
              type="text"
              className="itblog-search"
              placeholder="🔍  Search articles..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
            <div className="itblog-cats">
              {categories.map(cat => (
                <button
                  key={cat}
                  type="button"
                  className={activeCategory === cat ? 'itblog-cat itblog-cat--active' : 'itblog-cat'}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {/* Post Grid */}
          {filtered.length > 0 ? (
            <div className="itblog-grid">
              {filtered.map(post => (
                <article key={post.id} className="itblog-card">
                  <div className="itblog-card__thumb">
                    <span className="itblog-card__emoji">{post.emoji}</span>
                    <span className="itblog-card__cat-badge">{post.category}</span>
                  </div>
                  <div className="itblog-card__body">
                    <div className="itblog-card__meta">
                      <span>{post.date}</span>
                      <span>·</span>
                      <span>{post.readTime}</span>
                    </div>
                    <h3 className="itblog-card__title">{post.title}</h3>
                    <p className="itblog-card__excerpt">{post.excerpt}</p>
                    <Link to="/it-training/blog" className="itblog-card__read">Read More →</Link>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="itblog-empty">
              <span>😕</span>
              <p>No articles found. Try a different search or category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter */}
      <section className="itblog-newsletter">
        <div className="itp-container itblog-newsletter__inner">
          <div className="itblog-newsletter__text">
            <h3>Stay Updated with IT Trends</h3>
            <p>Get the latest articles, course updates, and career tips delivered to your inbox every week.</p>
          </div>
          <div className="itblog-newsletter__form">
            <input type="email" placeholder="Your email address" className="itblog-newsletter__input" />
            <Link to="/it-training/contact" className="itblog-newsletter__btn">Subscribe</Link>
          </div>
        </div>
      </section>

      <ITTrainingFooter />
    </div>
  );
}

export default ITBlog;
